import { SyndicationArticleClient, ArticleModel, SyndicationClient, SyndicationArticleDto, Language2, ArticleModelArticleType, ISyndicationArticleDto, Language4 } from "@/Generated/ParticaAPI";
import { IArticle } from "@/Models/ArticleModels/article";
import { ArticleUtils } from "./articleutils";

export interface ISyndicationArticleService {
	getSyndicationArticle(ArticleId: string): Promise<IArticle>;
	moveArticlesToProof(sydnicationArticles: SyndicationArticleDto[]): Promise<string[]>;
	moveArticleToProof(sydnicationArticle: SyndicationArticleDto): Promise<string[]>;
	approveArticle(sydnicationArticle: SyndicationArticleDto): Promise<string[]>;
	saveArticle(article: IArticle): Promise<IArticle>;
}

export class SyndicationArticleService implements ISyndicationArticleService {
	private svc: SyndicationArticleClient = new SyndicationArticleClient();
	private sydnicationsvc: SyndicationClient = new SyndicationClient();
	private utils: ArticleUtils = new ArticleUtils();
	public async getSyndicationArticle(ArticleId: string): Promise<IArticle> {
		const am: ArticleModel = await this.svc.articleGet(ArticleId);
		return this.utils.convertarticle<IArticle>(am);
	}
	public async moveArticlesToProof(sydnicationArticles: SyndicationArticleDto[]): Promise<string[]> {
		return await this.sydnicationsvc.moveToProof(sydnicationArticles, Language2.English);
	}
	public async moveArticleToProof(sydnicationArticle: SyndicationArticleDto): Promise<string[]> {
		const articles: SyndicationArticleDto[] = [];
		articles.push(sydnicationArticle);
		return await this.sydnicationsvc.moveToProof(articles, Language2.English);
	}
	public async approveArticle(sydnicationArticle: SyndicationArticleDto): Promise<string[]> {
		const articles: SyndicationArticleDto[] = [];
		articles.push(sydnicationArticle);
		return await this.sydnicationsvc.moveToApproved(articles, Language4.English);
	}
	public async saveArticle(article: IArticle): Promise<IArticle> {
		let am = article.get<ArticleModel>();
		am.issue = undefined;
		am.articleType = ArticleModelArticleType.Syndicationproof;
		am = await this.svc.saveArticle(am);
		return this.utils.convertarticle<IArticle>(am);
	}
}
